import { createContext } from "react";

const IncomingOrderMultiselectSelectionContext = createContext();

export default IncomingOrderMultiselectSelectionContext;
